import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout/Layout';
import Home from './Pages/Home/Home';
import Detail from './Pages/Listing/Detail';
import Login from './Pages/Auth/Login';
import { Toaster } from 'react-hot-toast';
import { Register } from './Pages/Auth/Register';
import CopartListing from './Pages/Listing/Copart/CopartListing';
import IaaiListing from './Pages/Listing/IAAI/IaaiListing';
import AllListing from './Pages/Listing/AllListing';
import TermsOfService from './Pages/Termcondition/TermCondition';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import RefundPolicy from './Pages/RefundPolicy/RefundPolicy';
import BuyVehicleSteps from './Pages/HowToBuy/HowToBuy';
import FAQPage from './Pages/Faqs/Faqs';
import ShippingForm from './Pages/ShippingForm/ShippingForm';
import EmailVerification from './Pages/Emailverification/Emailverification';
import VehicleFind from './Pages/Vehiclefind/VehicleFind';
import VehicleFinder from './Pages/VehicleFinder/VehicleFinder';
import Payment from './Pages/Payment/Payment';
import Contactus from './Pages/Resorcesenterpages/Contactus';
import Affiliates from './Pages/Resorcesenterpages/Affiliates';
import SearcBrand from './Pages/serarchbrand/SearcBrand';
import QuickSearch from './Pages/quicksearch/QuickSearch';
import Blogs from './Pages/blogs/Blogs';

function App() {
  return (
    <>
      <BrowserRouter>
        <Toaster
          position="top-right"
          reverseOrder={false}
        />
        <Layout>
          <Routes>
            <Route path="/Register" element={<Register />}></Route>
            <Route path="/blog" element={<Blogs/>}/>
            <Route path="/login" element={<Login />}></Route>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/copartListing" element={<CopartListing />} />
            <Route exact path="/iaaiListing" element={<IaaiListing />} />
            <Route exact path="/allListing" element={<AllListing />} />
            <Route exact path="/detail/:id" element={<Detail />} />
            <Route exact path="/term&condition" element={<TermsOfService />} />
            <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route exact path="/refundpolicy" element={<RefundPolicy />} />
            <Route exact path="/buyvehiclesteps" element={<BuyVehicleSteps />} />
            <Route exact path="/faqpage" element={<FAQPage/>} />
            <Route exact path="/shippingform" element={<ShippingForm/>} />
            <Route exact path="/emailverification/:token" element={<EmailVerification/>} />
            <Route exact path="/vehicleFind" element={<VehicleFind/>} />
            <Route exact path="/vehicleFinder" element={<VehicleFinder/>} />
            <Route exact path="/payment" element={<Payment/>} />
            <Route exact path="/contactus" element={<Contactus/>} />
            <Route exact path="/affiliates" element={<Affiliates/>} />
            <Route exact path="/searchbrand" element={<SearcBrand/>} />
            <Route exact path="/quicksearch" element={<QuickSearch/>} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </>
  );
}

export default App;
